import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgGridModule } from '@trademe/tangram';
import { MotorsVehicleDetailsDetailsSectionModule } from 'libs/motors-ui/src/lib/sections/motors-vehicle-details-details-section/motors-vehicle-details-details-section.module';
import { MotorsCannotEditSomethingMessageSectionModule } from 'libs/motors-ui/src/lib/sections/motors-cannot-edit-something-message-section/motors-cannot-edit-something-message-section.module';
import { MotorsVehicleDetailsHeaderSectionModule } from 'libs/motors-ui/src/lib/sections/motors-vehicle-details-header-section/motors-vehicle-details-header-section.module';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { BoatsAndMarineVehicleDetailsPageComponent } from './motors-vehicle-details-page.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        MotorsCannotEditSomethingMessageSectionModule,
        MotorsVehicleDetailsHeaderSectionModule,
        MotorsVehicleDetailsDetailsSectionModule
    ],
    declarations: [BoatsAndMarineVehicleDetailsPageComponent],
    providers: [TmDateComponent],
    exports: [BoatsAndMarineVehicleDetailsPageComponent]
})
export class BoatsAndMarineVehicleDetailsPageModule { }
